import { useTranslation } from "react-i18next";

/**
 * Centralized toast message keys and helpers
 * Ensures consistent i18n usage across the application
 */
export const useToastMessages = () => {
  const { t } = useTranslation();

  return {
    // Common messages
    saving: () => t("saving") || "Speichere...",
    error: () => t("error") || "Fehler aufgetreten",
    success: () => t("success") || "Erfolgreich",

    // Post-related messages
    postCreated: () => t("post.created") || "Beitrag erstellt",
    postUpdated: () => t("post.updated") || "Beitrag gespeichert",
    postPublished: () => t("post.published") || "Beitrag veröffentlicht",
    postUnpublished: () => t("post.unpublished") || "Beitrag zurückgezogen",
    postDeleted: () => t("post.deleted") || "Beitrag gelöscht",
    postError: () => t("post.error") || "Aktion fehlgeschlagen",
    postLoadError: () => t("post.loadError") || "Laden fehlgeschlagen",

    // Video-related messages
    videoSubmitted: () => t("video.submitted") || "Video eingereicht",
    videoSubmitError: () =>
      t("video.submitError") || "Einreichen fehlgeschlagen",
    seriesCreated: () => t("series.created") || "Serie erstellt",
    seriesUpdated: () => t("series.updated") || "Serie aktualisiert",
    seriesDeleted: () => t("series.deleted") || "Serie gelöscht",
    seriesError: () => t("series.error") || "Aktion fehlgeschlagen",
    seriesLoadError: () => t("series.loadError") || "Laden fehlgeschlagen",

    // Suggestion-related messages
    suggestionApproved: () => t("suggestion.approved") || "Status: APPROVED",
    suggestionRejected: () => t("suggestion.rejected") || "Status: REJECTED",
    suggestionDeleted: () => t("suggestion.deleted") || "Eintrag gelöscht",
    suggestionError: () => t("suggestion.error") || "Aktion fehlgeschlagen",
  };
};
